import React, { useState } from 'react';
import { FileText, Download, Calendar, TrendingUp, DollarSign, Users, Filter, Search } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function FinanceReports() {
  const [selectedPeriod, setSelectedPeriod] = useState('Q1-2025');
  const stats = [{
    label: 'Total Pendapatan',
    value: 'Rp 125.500.000',
    change: '+12.5%',
    icon: DollarSign,
    trend: 'up'
  }, {
    label: 'Iuran Terkumpul',
    value: 'Rp 98.000.000',
    change: '+8.3%',
    icon: TrendingUp,
    trend: 'up'
  }, {
    label: 'Anggota Aktif',
    value: '245',
    change: '+15',
    icon: Users,
    trend: 'up'
  }, {
    label: 'Laporan Bulan Ini',
    value: '12',
    change: '3 pending',
    icon: FileText,
    trend: 'neutral'
  }];
  const reports = [{
    id: 1,
    title: 'Laporan Keuangan Q1 2025',
    period: 'Jan - Mar 2025',
    type: 'Triwulanan',
    status: 'Selesai',
    date: '31 Mar 2025',
    size: '2.5 MB'
  }, {
    id: 2,
    title: 'Laporan Iuran Januari 2025',
    period: 'Januari 2025',
    type: 'Bulanan',
    status: 'Selesai',
    date: '31 Jan 2025',
    size: '1.8 MB'
  }, {
    id: 3,
    title: 'Laporan Iuran Februari 2025',
    period: 'Februari 2025',
    type: 'Bulanan',
    status: 'Selesai',
    date: '28 Feb 2025',
    size: '1.9 MB'
  }, {
    id: 4,
    title: 'Laporan Iuran Maret 2025',
    period: 'Maret 2025',
    type: 'Bulanan',
    status: 'Proses',
    date: '31 Mar 2025',
    size: '-'
  }, {
    id: 5,
    title: 'Laporan Acara Q1 2025',
    period: 'Jan - Mar 2025',
    type: 'Triwulanan',
    status: 'Proses',
    date: '31 Mar 2025',
    size: '-'
  }];
  return <div className="min-h-screen bg-white" data-id="element-3157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-3158">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-3159">
          <div data-id="element-3160">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-3161">
              Laporan Keuangan
            </h1>
            <p className="text-neutral-600" data-id="element-3162">
              Kelola dan unduh laporan keuangan ATIOS
            </p>
          </div>
          <div className="flex gap-3" data-id="element-3163">
            <Button variant="secondary" data-id="element-3164">
              <Filter className="w-4 h-4 mr-2" data-id="element-3165" />
              Filter
            </Button>
            <Button data-id="element-3166">
              <Download className="w-4 h-4 mr-2" data-id="element-3167" />
              Ekspor Semua
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3168">
          {stats.map((stat, i) => <Card key={i} data-id="element-3169">
              <CardContent className="p-6" data-id="element-3170">
                <div className="flex items-center justify-between mb-4" data-id="element-3171">
                  <div className={`p-3 rounded-lg bg-${stat.trend === 'up' ? 'success' : 'neutral'}-light`} data-id="element-3172">
                    <stat.icon className={`w-6 h-6 text-${stat.trend === 'up' ? 'success' : 'neutral-700'}`} data-id="element-3173" />
                  </div>
                  {stat.trend === 'up' && <Badge variant="success" className="text-xs" data-id="element-3174">
                      {stat.change}
                    </Badge>}
                </div>
                <h3 className="text-2xl font-semibold text-neutral-900 mb-1" data-id="element-3175">
                  {stat.value}
                </h3>
                <p className="text-sm text-neutral-600" data-id="element-3176">{stat.label}</p>
              </CardContent>
            </Card>)}
        </div>

        {/* Search & Period Selector */}
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-3177">
          <div className="flex-1 relative" data-id="element-3178">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-3179" />
            <Input placeholder="Cari laporan..." className="pl-10" data-id="element-3180" />
          </div>
          <select value={selectedPeriod} onChange={e => setSelectedPeriod(e.target.value)} className="px-4 py-2 rounded-lg border border-neutral-300 bg-white text-sm text-neutral-900 focus:outline-none focus:ring-2 focus:ring-atios-primary" data-id="element-3181">
            <option value="Q1-2025" data-id="element-3182">Q1 2025</option>
            <option value="Q4-2024" data-id="element-3183">Q4 2024</option>
            <option value="Q3-2024" data-id="element-3184">Q3 2024</option>
            <option value="Q2-2024" data-id="element-3185">Q2 2024</option>
          </select>
        </div>

        {/* Reports Table */}
        <Card data-id="element-3186">
          <CardHeader data-id="element-3187">
            <CardTitle data-id="element-3188">Daftar Laporan</CardTitle>
          </CardHeader>
          <CardContent data-id="element-3189">
            <Table data-id="element-3190">
              <TableHeader data-id="element-3191">
                <TableRow data-id="element-3192">
                  <TableHead data-id="element-3193">Judul Laporan</TableHead>
                  <TableHead data-id="element-3194">Periode</TableHead>
                  <TableHead data-id="element-3195">Jenis</TableHead>
                  <TableHead data-id="element-3196">Status</TableHead>
                  <TableHead data-id="element-3197">Tanggal</TableHead>
                  <TableHead data-id="element-3198">Ukuran</TableHead>
                  <TableHead className="text-right" data-id="element-3199">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-3200">
                {reports.map(report => <TableRow key={report.id} data-id="element-3201">
                    <TableCell className="font-medium text-neutral-900" data-id="element-3202">
                      {report.title}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-3203">
                      {report.period}
                    </TableCell>
                    <TableCell data-id="element-3204">
                      <Badge variant="default" data-id="element-3205">{report.type}</Badge>
                    </TableCell>
                    <TableCell data-id="element-3206">
                      <Badge variant={report.status === 'Selesai' ? 'success' : 'warning'} data-id="element-3207">
                        {report.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-3208">
                      {report.date}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-3209">
                      {report.size}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-3210">
                      <Button size="sm" variant="secondary" disabled={report.status !== 'Selesai'} data-id="element-3211">
                        <Download className="w-4 h-4 mr-2" data-id="element-3212" />
                        Unduh
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Summary Card */}
        <Card className="bg-gradient-to-r from-atios-light to-white border-atios-primary/20" data-id="element-3213">
          <CardContent className="p-8" data-id="element-3214">
            <div className="flex items-center gap-4" data-id="element-3215">
              <div className="h-16 w-16 rounded-lg bg-atios-primary flex items-center justify-center" data-id="element-3216">
                <FileText className="h-8 w-8 text-white" data-id="element-3217" />
              </div>
              <div className="flex-1" data-id="element-3218">
                <h3 className="text-xl font-semibold text-neutral-900 mb-1" data-id="element-3219">
                  Butuh Laporan Khusus?
                </h3>
                <p className="text-neutral-600" data-id="element-3220">
                  Hubungi tim keuangan untuk membuat laporan keuangan custom
                  sesuai kebutuhan Anda
                </p>
              </div>
              <Button size="lg" data-id="element-3221">Hubungi Tim</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}